import { HelpCircle } from "lucide-react";

// Extracted from CompliancePage.jsx's FAQ list so it can be reused on other
// pages (e.g. CorporatePartnersPage) without duplicating it. Already fully
// generic (props only, no internal translation calls) — moved as-is.
const FAQItem = ({ question, answer }) => (
  <div className="border-b border-slate-200 py-6">
    <div className="flex gap-4">
      <HelpCircle className="text-gold w-5 h-5 flex-shrink-0 mt-1" strokeWidth={2} />
      <div>
        <h4 className="font-outfit font-semibold text-navy mb-2">{question}</h4>
        <p className="text-slate-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  </div>
);

export default FAQItem;
